import React from "react";
import { Card, CardMedia, Box } from "@mui/material";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import Video from "./mainSection2Video.mp4";
import SliderComponent from "../SliderComponent/SliderComponent";
import SliderImage from "../SliderComponent/SliderImage";

const VideoCard = () => {
  const { scrollY } = useViewportScroll();

  // Tilt the box forward initiallyand straighten it out as you scroll
  const tilt = useTransform(scrollY, [0, 800], [80, 0]);

  return (
    <Box
      sx={{
        marginTop: { xl: "35px", lg: "40px", md: "40px" },
        overflow: "hidden", // Hide any overflow caused by tilting
        maxWidth: "100vw", // Ensure no overflow horizontally
        padding: { xs: 0, sm: 0 }, // Remove padding to avoid overflow
      }}
    >
      <motion.div style={{ perspective: 1000 }}>
        <motion.div
          style={{
            rotateX: tilt,
            // border: "1px solid red",
          }}
          transition={{
            type: "spring",
            stiffness: 120, // Lower stiffness for smoother transition
            damping: 60, // Damping to control bounce
          }}
        >
          <Card
            sx={{
              width: { lg: "80%", xl: "70%", md: "90%", sm: "90%", xs: "92%" },
              height: {
                lg: "84%",
                xl: "100%",
                md: "86%",
                sm: "90%",
                xs: "50vh",
              },
              // maxWidth: "1140px",
              maxWidth: "1940px",
              // maxWidth: "1640px",
              maxHeight: "864px",
              margin: "auto",
              boxShadow: 3,
              borderRadius: 2,
              overflow: "hidden",
              position: "relative",
              border: {
                lg: "15px solid #313136",
                xl: "15px solid #313136",
                md: "15px solid #313136",
                sm: "8px solid #313136",
                xs: "8px solid #313136",              
              },
            }}
          >
            {/* <CardMedia
              component="video"
              src={Video}
              autoPlay
              loop
              muted
              sx={{
                width: "100%",
                height: "auto",
              }}
            /> */}
            <SliderComponent />
            {/* <SliderImage /> */}

        
          </Card>
        </motion.div>
      </motion.div>
    </Box>
  );
};

export default VideoCard;
